import * as React from "react";
import { useState } from "react";
import cloneDeep from "lodash/cloneDeep";
import omit from "lodash/omit";
import { Alert, Col, Row } from "components/bootstrap";
import EventKeyHelpPopover from "components/event-definitions/common/EventKeyHelpPopover";
import HoverForHelp from "components/common/HoverForHelp";
import FieldForm from "./FieldForm";
import FieldsList from "./FieldsList";
import { isSystemEventDefinition } from "../event-definitions-types";
import commonStyles from "../common/commonStyles.css";
const FieldsForm = ({ currentUser, eventDefinition, validation, onChange, canEdit }) => {
  var _a, _b, _c, _d;
  const [editField, setEditField] = useState(void 0);
  const [showFieldForm, setShowFieldForm] = useState(false);
  const removeCustomField = (fieldName) => {
    const nextFieldSpec = omit(eventDefinition.field_spec, fieldName);
    onChange("field_spec", nextFieldSpec);
    const fieldNames = Object.keys(nextFieldSpec);
    const nextKeySpec = eventDefinition.key_spec.filter((key) => fieldNames.includes(key));
    onChange("key_spec", nextKeySpec);
  };
  const toggleFieldForm = (fieldName) => {
    setEditField(showFieldForm ? void 0 : fieldName);
    setShowFieldForm(!showFieldForm);
  };
  const addCustomField = (prevFieldName, fieldName, config, isKey, keyPosition) => {
    const nextFieldSpec = prevFieldName === fieldName ? cloneDeep(eventDefinition.field_spec) : omit(eventDefinition.field_spec, prevFieldName);
    nextFieldSpec[fieldName] = config;
    onChange("field_spec", nextFieldSpec);
    const fieldNames = Object.keys(nextFieldSpec);
    let nextKeySpec = eventDefinition.key_spec.filter((key) => fieldNames.includes(key) && key !== fieldName);
    if (isKey) {
      nextKeySpec = [...nextKeySpec.slice(0, keyPosition), fieldName, ...nextKeySpec.slice(keyPosition)];
    }
    onChange("key_spec", nextKeySpec);
    toggleFieldForm();
  };
  const canEditCondition = canEdit && !isSystemEventDefinition(eventDefinition);
  if (showFieldForm) {
    return /* @__PURE__ */ React.createElement(
      FieldForm,
      {
        keys: eventDefinition.key_spec,
        fieldName: editField,
        config: editField ? eventDefinition.field_spec[editField] : void 0,
        onChange: addCustomField,
        onCancel: toggleFieldForm,
        currentUser
      }
    );
  }
  const fieldErrors = (_b = (_a = validation == null ? void 0 : validation.errors) == null ? void 0 : _a.field_spec) != null ? _b : [];
  const keyErrors = (_d = (_c = validation == null ? void 0 : validation.errors) == null ? void 0 : _c.key_spec) != null ? _d : [];
  const errors = [...fieldErrors, ...keyErrors];
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("h2", { className: commonStyles.title }, "Event Fields ", /* @__PURE__ */ React.createElement("small", null, "(optional)")), !canEditCondition ? /* @__PURE__ */ React.createElement("p", null, "The event fields of this event definition type cannot be edited.") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "Include additional information in Events generated from this Event Definition by adding custom Fields. That can help you search Events or having more context when receiving Notifications."), errors.length > 0 && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", className: commonStyles.validationSummary, title: "Fields with errors" }, /* @__PURE__ */ React.createElement("p", null, "Please correct the following errors before saving this Event Definition:"), /* @__PURE__ */ React.createElement("ul", null, errors.map((error) => /* @__PURE__ */ React.createElement("li", { key: error }, error)))), Object.keys(eventDefinition.field_spec).length > 0 && /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Keys", /* @__PURE__ */ React.createElement(HoverForHelp, { title: "More about Event Keys", trigger: ["click", "hover"], placement: "right" }, /* @__PURE__ */ React.createElement(EventKeyHelpPopover, null))), /* @__PURE__ */ React.createElement("dd", null, eventDefinition.key_spec.length > 0 ? eventDefinition.key_spec.join(", ") : "No Keys configured yet.")), /* @__PURE__ */ React.createElement(
    FieldsList,
    {
      fields: eventDefinition.field_spec,
      validation,
      keys: eventDefinition.key_spec,
      onAddFieldClick: toggleFieldForm,
      onEditFieldClick: toggleFieldForm,
      onRemoveFieldClick: removeCustomField
    }
  ))));
};
export default FieldsForm;
